export default {
  START_OVER: 'Remove all',
  TOTAL_HITS: 'products',

  FILTERS_TEXT: 'Filter',

  FACET_DIALOG_TITLE: 'Filter',
  FACET_DIALOG_CLEAR: 'Remove all',
  FACET_DIALOG_DONE: 'Apply',
  FACET_DIALOG_RESULTS: 'products',
};
